import { APP_COUNTRY } from 'config';
import closeIcon from 'images/icons/close-icon.svg';
import { useState } from 'react';
import media from 'style-utils/media-queries';
import styled, { css } from 'styled-components';
import { useCustomEvent } from 'utils/hooks/use-custom-event';

export default function VivochaHelpCenterContainer() {
  const [isOpen, setIsOpen] = useState(false);

  const close = () => {
    setIsOpen(false);
  };

  useCustomEvent<{ show: boolean }>({
    eventName: 'vivocha-container',
    onSignal(e) {
      setIsOpen(e.detail.show);
    },
  });

  return (
    <VvcHcPopupContainer
      className="vvc-hc-popup-container"
      style={{ display: isOpen ? 'block' : 'none' }}
    >
      <VvcHcPopup className="vvc-hc-popup">
        <VvcHcPopupClose className="vvc-hc-popup-close" onClick={close}>
          <VvcCloseButton className="vvc-close"></VvcCloseButton>
        </VvcHcPopupClose>

        <VvcHcAppContainer className="vvc-hc-app-container">
          <VvcHcAppIframe
            title="Vivocha Help Center"
            id="vvc-hc-app"
            className="hcFrame"
          />
        </VvcHcAppContainer>
      </VvcHcPopup>
    </VvcHcPopupContainer>
  );
}

const VvcHcPopupContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 501;
  width: 100dvw;
  background-color: white;
  ${function getPadding() {
    if (APP_COUNTRY === 'fr' || APP_COUNTRY === 'es')
      return css`
        padding-top: var(--betting-banner-height);
        ${media.desktop`padding-top: var(--betting-banner-height-md);`}
      `;
  }}
`;

const VvcHcPopup = styled.div`
  height: 100dvh;
`;

const VvcHcPopupClose = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 48px;
  padding-right: 24px;
`;

const VvcCloseButton = styled.button`
  background: no-repeat center url(${closeIcon});
  width: 14px;
  border: none;
  cursor: pointer;
`;

const VvcHcAppContainer = styled.div`
  height: 100%;
`;

const VvcHcAppIframe = styled.iframe`
  border: none;
  ${function getHeight() {
    if (APP_COUNTRY === 'fr' || APP_COUNTRY === 'es')
      return css`
        height: calc(100% - var(--betting-banner-height) - 48px);
        ${media.desktop`height: calc(100% - var(--betting-banner-height-md) - 48px);`}
      `;
  }}
  width: 100%;
`;
